/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CreateTodoResponse
 */
export interface CreateTodoResponse {
  /**
   *
   * @type {string}
   * @memberof CreateTodoResponse
   */
  todoId: string;
}

/**
 * Check if a given object implements the CreateTodoResponse interface.
 */
export function instanceOfCreateTodoResponse(
  value: object,
): value is CreateTodoResponse {
  if (!("todoId" in value) || value["todoId"] === undefined) return false;
  return true;
}

export function CreateTodoResponseFromJSON(json: any): CreateTodoResponse {
  return CreateTodoResponseFromJSONTyped(json, false);
}

export function CreateTodoResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CreateTodoResponse {
  if (json == null) {
    return json;
  }
  return {
    todoId: json["todoId"],
  };
}

export function CreateTodoResponseToJSON(json: any): CreateTodoResponse {
  return CreateTodoResponseToJSONTyped(json, false);
}

export function CreateTodoResponseToJSONTyped(
  value?: CreateTodoResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    todoId: value["todoId"],
  };
}
